<template>
  <div style="position: relative; height: 100%" class="ivu-modal-body">
    <Spin v-if="loadingStatus" fix />
    <Form v-if="objectId > 0 && Object.keys(formFields.items).length > 0" ref="form" :label-width="90" :model="formFields">
      <FormItem
        v-for="(item,index) in paramList"
        :key="index"
        :label="item.label"
        :prop="item.key"
      >
        <Input v-model="formFields.items[index].value" size="small" />
      </FormItem>
      <div class="text-right">
        <Button
          type="primary"
          :disabled="loadingStatus"
          icon="ios-checkmark-circle-outline"
          :loading="submit"
          @click="saveAndProvisioning"
        >
          保存并下发
        </Button>
      </div>
    </Form>
    <div v-else style="display: flex;align-items: center;justify-content: center; height: 100%">
      <span v-if="objectId < 1">
        请从车库拓扑图中选择一个车库或者终端加载配置参数...
      </span>
      <span v-if="objectId > 0 && Object.keys(formFields.items).length === 0">
        参数模板尚未定制或者不支持参数...
      </span>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  name: 'ProvisioningParameter',
  components: {
  },
  props: {
    caption: {
      type: String,
      default: ''
    },
    objectId: {
      type: Number,
      default: 0
    },
    objectType: {
      type: Number,
      default: 0
    },
    changed: {
      type: Boolean,
      default: false
    },
    objectName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loadingStatus: false,
      submit: false,
      paramList: [],
      formFields: {
        items: []
      }
    }
  },
  computed: {
    formRefresh: {
      get() { return this.changed },
      set(value) { }
    }
  },
  watch: {
    objectId(newValue, oldValue) {
      this.loadParameters(this.objectId, this.objectType)
    }
  },
  mounted: function() {
  },
  methods: {
    loadParameters: function(objectId, objectType) {
      this.loadingStatus = true
      this.paramList = []

      const fields = {
        objectId: this.objectType,
        type: this.objectType,
        items: []
      }

      request({
        url: this.$config.apiContextPath + '/parameter/' + objectId + '?type=' + objectType,
        method: 'get'
      }).then(res => {
        const params = res.data
        for (const param of params) {
          fields.items.push({
            key: param.parameterKey,
            value: param.parameterValue,
            parameterId: param.parameterId,
            id: param.id || -1
          })

          this.paramList.push({
            label: param.parameterDesc,
            key: param.parameterKey,
            value: param.parameterValue
          })
        }
        this.formFields = fields
        this.loadingStatus = false
      }).catch(error => {
        this.loadingStatus = false
        console.log(error)
      })
    },
    saveAndProvisioning: function() {
      const _that = this
      const _url = this.$config.apiContextPath + '/parameter/' + _that.objectId + '?type=' + _that.objectType
      this.$Modal.confirm({
        title: '确定要保存并下发参数么？',
        loading: true,
        render: (h, params) => {
          return h('ul', { style: { padding: '10px 25px 0' }}, [h('li', {}, this.objectName)])
        },
        onOk: function() {
          _that.submit = true
          request({
            url: _url,
            method: 'POST',
            data: _that.formFields.items
          }).then(res => {
            this.$Notice.success({
              title: '参数保存成功且已下发至终端!'
            })
            _that.submit = false
            _that.buttonLoading = false
            this.$Modal.remove()
          }).catch(() => {
            // this.$Notice.error({
            //   title: '服务器数据请求失败',
            //   desc: '请求地址: ' + _url + ', 错误信息: ' + error
            // })
            _that.submit = false
            _that.buttonLoading = false
            this.$Modal.remove()
          })
        }
      })
    }
  }
}
</script>
